/* =========================================================
   QuenchSea homepage buy section (sections/qs-buy-box.liquid)
   Gallery, kit selector, AJAX add to cart. After adding, it opens the
   theme's cart drawer (Dawn <cart-drawer>) when the theme uses one, or else
   the cart notification (Dawn <cart-notification>) with every line item
   that was just added.
   ========================================================= */
(function () {
  'use strict';
  if (window.__qsBuyBoxInit) return;
  window.__qsBuyBoxInit = true;

  var NOTIFY_SECTIONS = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
  var DRAWER_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function themeDrawer() {
    var d = document.querySelector('cart-drawer');
    return d && typeof d.renderContents === 'function' ? d : null;
  }

  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function routes() { return window.routes || {}; }

  function sectionHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector || '.shopify-section');
    return el ? el.innerHTML : null;
  }

  /* ---------- cart ---------- */
  function addItems(variantIds) {
    var notification = document.querySelector('cart-notification');
    var body = { items: variantIds.map(function (id) { return { id: Number(id), quantity: 1 }; }) };
    if (themeDrawer()) {
      body.sections = DRAWER_SECTIONS;
      body.sections_url = window.location.pathname;
    } else if (notification) {
      body.sections = NOTIFY_SECTIONS;
      body.sections_url = window.location.pathname;
    }
    return fetch((routes().cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok || json.status) throw new Error(json.description || json.message || '');
          return json;
        });
      })
      .then(function (json) {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'qs-buy-box', cartData: json });
        }
        showNotification(json);
        return json;
      });
  }

  // Render every added line into the theme's notification and open it.
  // The theme's own renderContents() only shows one line item, so a kit would lose lines.
  function showNotification(json) {
    var drawer = themeDrawer();
    if (drawer && json.sections && json.sections['cart-drawer']) {
      drawer.classList.remove('is-empty');
      drawer.renderContents(json);
      return;
    }
    var notification = document.querySelector('cart-notification');
    if (!notification || !json.sections || typeof notification.open !== 'function') {
      window.location.href = routes().cart_url || '/cart';
      return;
    }
    var productsHTML = json.sections['cart-notification-product'];
    var target = document.getElementById('cart-notification-product');
    if (productsHTML && target) {
      var doc = new DOMParser().parseFromString(productsHTML, 'text/html');
      target.innerHTML = (json.items || []).map(function (item) {
        var el = doc.querySelector('[id="cart-notification-product-' + item.key + '"]');
        return el ? el.outerHTML : '';
      }).join('');
    }
    ['cart-notification-button', 'cart-icon-bubble'].forEach(function (id) {
      var el = document.getElementById(id);
      var html = json.sections[id] && sectionHTML(json.sections[id]);
      if (el && html !== null) el.innerHTML = html;
    });
    if (notification.header && notification.header.reveal) notification.header.reveal();
    notification.open();
  }

  function showError(el, err, fallback) {
    if (!el) return;
    el.textContent = (err && err.message) || fallback;
    el.hidden = false;
  }

  /* ---------- gallery ---------- */
  function initGallery(root) {
    var slides = all(root, '[data-qbb-slide]');
    var thumbs = all(root, '[data-qbb-thumb]');

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        slides.forEach(function (slide, i) {
          slide.hidden = i !== index;
          if (i !== index) all(slide, 'video').forEach(function (v) { v.pause(); });
        });
        thumbs.forEach(function (t, i) { t.setAttribute('aria-pressed', i === index ? 'true' : 'false'); });
      });
    });

    all(root, '[data-qbb-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var slide = btn.closest('[data-qbb-slide]');
        var embed = btn.getAttribute('data-embed');
        var video = slide.querySelector('video');
        if (embed) {
          var frame = document.createElement('iframe');
          frame.src = embed;
          frame.title = btn.textContent.trim();
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.setAttribute('allowfullscreen', '');
          slide.appendChild(frame);
          var poster = slide.querySelector('.qbb-poster');
          if (poster) poster.hidden = true;
        } else if (video) {
          video.setAttribute('controls', '');
          video.play();
        }
        btn.hidden = true;
      });
    });
  }

  /* ---------- kits + main button ---------- */
  function initBuy(root) {
    var cta = root.querySelector('[data-qbb-add]');
    if (!cta) return;
    var priceEl = root.querySelector('[data-qbb-price]');
    var ctaPrice = root.querySelector('[data-qbb-cta-price]');
    var errorEl = root.querySelector('[data-qbb-error]');
    var radios = all(root, '[data-qbb-kit]');

    function current() {
      var checked = radios.filter(function (r) { return r.checked; })[0] || cta;
      return {
        variants: (checked.getAttribute('data-variants') || '').split(',').filter(Boolean),
        price: checked.getAttribute('data-price')
      };
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        var c = current();
        if (priceEl) priceEl.textContent = c.price;
        if (ctaPrice) ctaPrice.textContent = c.price;
        if (errorEl) errorEl.hidden = true;
      });
    });

    cta.addEventListener('click', function () {
      var c = current();
      if (cta.disabled || !c.variants.length) return;
      cta.disabled = true;
      cta.classList.add('is-loading');
      cta.setAttribute('aria-busy', 'true');
      if (errorEl) errorEl.hidden = true;
      addItems(c.variants)
        .catch(function (err) { showError(errorEl, err, cta.getAttribute('data-error')); })
        .then(function () {
          cta.disabled = false;
          cta.classList.remove('is-loading');
          cta.removeAttribute('aria-busy');
        });
    });
  }

  /* ---------- spare part buttons ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.qs-buy-box [data-qbb-add-variant]');
    if (!btn || btn.disabled) return;
    var card = btn.closest('.qbb-part');
    var errorEl = card && card.querySelector('[data-qbb-error]');
    btn.disabled = true;
    if (errorEl) errorEl.hidden = true;
    addItems([btn.getAttribute('data-qbb-add-variant')])
      .catch(function (err) { showError(errorEl, err, btn.getAttribute('data-error')); })
      .then(function () { btn.disabled = false; });
  });

  /* ---------- init + theme editor ---------- */
  function init(scope) {
    all(scope, '.qs-buy-box:not([data-qbb-ready])').forEach(function (root) {
      root.setAttribute('data-qbb-ready', '');
      initGallery(root);
      initBuy(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
